export const get_full_address = (address) => {
    let full_address = "";
    if (address.street) {
      full_address += address.street + " ";
    }
    if (address.street_number) {
      full_address += address.street_number;
    }
    if (address.references) {
      full_address += ", " + address.references;
    }
    if (address.commune) {
      full_address += ", " + address.commune;
    }
    if (address.region) {
      full_address += ", " + address.region;
    }
    return full_address;
  }